<template>
  <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
      <el-form-item label="是否推送凭证" prop="isSendpz">
        <el-radio-group v-model="form.isSendpz">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否允许修改入账流水的原因和金额" prop="allowEdit">
        <el-radio-group v-model="form.allowEdit">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="金钱类型" prop="moneyType">
       <el-select v-model="form.moneyType" placeholder="请选择金钱类型">
        <el-option label="余额" :value="1"></el-option>
        <el-option label="零售价" :value="2"></el-option>
        <el-option label="学费" :value="3"></el-option>
        <el-option label="积分" :value="4"></el-option>
       </el-select>
      </el-form-item>
      <el-form-item label="赠送原因" prop="configName">
        <el-input v-model="form.configName" placeholder="请输入赠送原因" />
      </el-form-item>
      <el-form-item label="赠送类型" prop="dataType">
        <el-radio-group v-model="form.dataType">
          <el-radio :label="1">账户管理(推用友)(需要配借贷编码)</el-radio>
          <el-radio :label="2">其他(不需要配借贷编码)</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="key" prop="configKey">
        <el-input v-model="form.configKey" placeholder="请输入key" :disabled="form.id" />
      </el-form-item>
      <!-- <el-form-item label="借编码" :prop="form.dataType === 1 ? 'lendCode' : ''">
        <el-input v-model="form.lendCode" placeholder="请输入借编码" />
      </el-form-item>
      <el-form-item label="贷编码" :prop="form.dataType === 1 ? 'loanCode' : ''">
        <el-input v-model="form.loanCode" placeholder="请输入贷编码" />
      </el-form-item> -->
      <el-form-item label="状态" prop="state">
        <el-switch v-model="form.state" :active-value="true" :inactive-value="false"></el-switch>{{form.isEnable?'启用':'禁用'}}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysGiftAccountReasonApi from '@/api/config/sysGiftAccountReason'
import { guid } from "@/utils/index"
function initFormBean() {
  const formBean = {
    configName: null,
    configKey: null,
    lendCode: null,
    loanCode: null,
    dataType: null,
    isSendpz: null,
    allowEdit: null,
    moneyType: null,
    state: false,
  }
  return formBean
}

export default {
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        configName: [{ required: true, message: '请输入赠送原因', trigger: 'blur' }],
        isSendpz: [{ required: true, message: '请选择是否推送凭证', trigger: 'change' }],
        allowEdit: [{ required: true, message: '请选择是否允许修改入账流水的原因和金额', trigger: 'change' }],
        moneyType: [{ required: true, message: '请选择', trigger: 'change' }],
        configKey: [{ required: true, message: '请输入key', trigger: 'blur' }],
        dataType: [{ required: true, message: '请选择赠送类型', trigger: 'change' }],
        lendCode: [{ required: true, message: '请输入借编码', trigger: 'blur' }],
        loanCode: [{ required: true, message: '请输入贷编码', trigger: 'blur' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false,
    }
  },
  created() {
  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.isRepSub = false
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.form.configKey = guid()
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            sysGiftAccountReasonApi.update(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            
            sysGiftAccountReasonApi.create(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
      
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
</style>
